import { createSlice } from '@reduxjs/toolkit';

const initialState = [
  { key: "JeopardyBanner", displaypages: ["home", "plan-details"], priority: 1, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "User-Suspended", displaypages: ["home", "view-payments", "plan-details"], priority: 1, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "CCBanner", displaypages: ["home", "view-payments", "payment-methods"], priority: 2, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "RoadBoreBanner", displaypages: ["home", "appointments"], priority: 3, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "BDBanner", displaypages: ["home", "appointments"], priority: 4, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "Initial-login-CTL-Welcome", displaypages: ["home"], priority: 5, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "ReferalBanner", displaypages: ["home"], priority: 6, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "Initial-login-CTL-User", displaypages: ["account-info"], priority: 7, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "User-Suspended-Vacation", displaypages: ["home", "plan-details", "account-info"], priority: 8, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "disableChangePlanFeatureNotification", displaypages: ["plan-details"], priority: 9, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "changePlanPreInstallation", displaypages: ["plan-details"], priority: 10, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "changePlanPending", displaypages: ["plan-details"], priority: 11, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "Download-Banner", displaypages: ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"], priority: 12, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "PaymentArrangements", displaypages: [" "], priority: 13, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "ModemRestarted", displaypages: [" "], priority: 14, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "AutoPayRemoval", displaypages: ["payment-methods"], priority: 15, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  { key: "qbpBanner", displaypages: ["agent-quick-bill-pay"], priority: 16, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  {key: "InstallationExtendBanner" , displaypages: ["home"], priority: 2, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  {key: "DSL-Migrator" , displaypages: ["home", "view-payments", "payment-methods", "appointments", "account-info", "plan-details", "network-info", "help-and-support"], priority: 2, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
  {key: "BUser-Suspended", displaypages: ["home"], priority: 1, active: false, notificationFlag: false, notificationMsdRead:false, Bannerflag: false, displayon: false },
];

const mySlice = createSlice({
  name: 'mySlice',
  initialState,
  reducers: {
    // Update a specific property for an object based on its key
    setActiveByKey: (state, action) => {
      const { key, value } = action.payload;
      const item = state.find(item => item.key === key);
      if (item) {
        item.active = value;
        // Reshuffle the state after updating the active status
        reshuffleState(state);
      }
    },
    setNotificationFlagByKey: (state, action) => {
      const { key, value } = action.payload;
      const item = state.find(item => item.key === key);
      if (item) {
        item.notificationFlag = value;
        reshuffleState(state);
      }
    },
    setNotificationMsdReadByKey : (state, action) => {
      const { key, value } = action.payload;
      const item = state.find(item => item.key === key);
      if (item) {
        item.notificationMsdRead = value;
        reshuffleState(state);
      }
    },
    setBannerFlagByKey: (state, action) => {
      const { key, value } = action.payload;
      const item = state.find(item => item.key === key);
      if (item) {
        item.Bannerflag = value;
        reshuffleState(state);
      }
    },
    resetAllBanners: (state) => {
      state.forEach(item => {
        item.active = false;
        item.notificationFlag = false;
        item.notificationMsdRead = false;
        item.Bannerflag = false;
        item.displayon = false;
      });
    },
    setDisplayOnByKey: (state, action) => {
      const { key, value } = action.payload;
      const item = state.find(item => item.key === key);
      if (item) {
        item.displayon = value;
        reshuffleState(state);
      }
    },
  },
});

// Helper function to reshuffle the state based on active status and priority
const reshuffleState = (state: any) => {
  state.sort((a: any, b: any) => {
    // First, prioritize active items
    if (a.active !== b.active) {
      return a.active ? -1 : 1; // active items come first
    }

    // Then, sort by priority
    return a.priority - b.priority; // Ascending order of priority
  });
};

export const { setActiveByKey, setNotificationFlagByKey, setBannerFlagByKey, setDisplayOnByKey, setNotificationMsdReadByKey, resetAllBanners } = mySlice.actions;
export default mySlice.reducer;
